import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { ArrowCircleLeft, ArrowCircleRight } from "@mui/icons-material";
import { themes } from "services/constants";
import sessionHandling from "services/utils/notificationUtils";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { showToast } from "services/utils/Status";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { useForm } from "react-hook-form";
import { useFetch } from "services/hooks/useFetch";
export const MoveEmployee = ({
  setMoveEmployee,
  viewAssignDetails,
  reCallApi,
}) => {
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    
    formState: { errors },
  } = useForm({ mode: "onBlur" });
  const { domain, token } = useSelector((state) => state.tokenReducer);
  const { result: department } = useFetch(`${domain}work-unit-department/`);
  const [departmentId, setDepartmentId] = useState(
    viewAssignDetails?.department
  );
  const [groupName, setGroupName] = useState("");
  const [RigthgroupName, setRightGroupName] = useState("");

  const [departmentName, setDepartmentName] = useState("");
  const { result: workUnitGroup, setLoad: reloadWorkUnit } = useFetch(
    `${domain}work_unit_groups/?department=${departmentId}`
  );
  const [leftSideEmployee, setLeftSideEmployee] = useState([]);
  const [rightSideEmployee, setRightSideEmployee] = useState([]);
  const [leftChecked, setLeftChecked] = useState(false);
  const [rightChecked, setRightChecked] = useState(false);
  const [groupId, setGroupId] = useState(viewAssignDetails?.id);
  const [newGroupId, setNewGroupId] = useState(viewAssignDetails?.id);

  useEffect(() => {
    setValue("department_name", viewAssignDetails?.department_name);
    setValue("name", viewAssignDetails?.name);
    setValue("id", viewAssignDetails?.id);
    setValue("department", viewAssignDetails.department);
    setDepartmentName(viewAssignDetails?.department_name);
    setGroupName(viewAssignDetails?.name);
  }, [
    reloadWorkUnit,
    setValue,
    viewAssignDetails.department,
    viewAssignDetails?.department_name,
    viewAssignDetails?.id,
    viewAssignDetails?.name,
  ]);

  const handleDepartment = (event, data) => {
    if (data) {
      setDepartmentId(data?.id);
      setValue("department_name", data?.label);
      setValue("id", data?.id);
      setDepartmentName(data?.label);
      reloadWorkUnit(true);
      setLeftSideEmployee([]);
      setRightSideEmployee([]);
      setGroupName("");
    } else {
      setValue("department_name", "");
      setValue("id", null);
      setDepartmentName("");
      setLeftSideEmployee([]);
      setRightSideEmployee([]);
      setGroupName("");
    }
  };

  const onSubmit = async (data) => {
    if (rightSideEmployee.length !== 0) {
      let userId = [];
      rightSideEmployee.forEach((element) => {
        userId.push(element?.user_id);
      });
      try {
        const response = await fetch(`${domain}unit/reassign/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
          body: JSON.stringify({
            users: userId,
            old_group: groupId,
            new_group: newGroupId,
            from_date: data.effective_from,
          }),
        });
        const res = await response.json();
        if (response.ok) {
          setMoveEmployee(false);
          reCallApi(true);
          showToast("success", res.message);
          reset();
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    } else {
      showToast("error", "Please select atleast one users");
    }
  };

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await fetch(
          `${domain}assignment_details/${groupId}/employee_details/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          let checkKey = res.map((data) => ({
            ...data,
            checked: false,
          }));
          setLeftSideEmployee(checkKey);
          setRightSideEmployee([]);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };

    if (groupId) {
      fetchEmployees();
    }
  }, [domain, groupId, token]);

  // const numberOfChecked = () => {
  //   let count = 0;
  //   leftSideEmployee.forEach((data) => {
  //     if (data.checked) {
  //       count = count + 1;
  //     }
  //   });
  //   return count;
  // };

  const handleToggleLeft = (value) => () => {
    setLeftChecked(false);
    setRightChecked(true);
    if (value.checked) {
      let updatedData = leftSideEmployee.map((data) => {
        if (data.user_id === value.user_id) {
          return {
            ...data,
            checked: false,
          };
        } else {
          return data;
        }
      });
      setLeftSideEmployee(updatedData);
    } else {
      let updatedData = leftSideEmployee.map((data) => {
        if (data.user_id === value.user_id) {
          return {
            ...data,
            checked: true,
          };
        } else {
          return data;
        }
      });
      setLeftSideEmployee(updatedData);
    }
  };

  const handleToggleRigh = (value) => () => {
    setLeftChecked(true);
    setRightChecked(false);
    if (value.checked) {
      let updatedData = rightSideEmployee.map((data) => {
        if (data.user_id === value.user_id) {
          return {
            ...data,
            checked: false,
          };
        } else {
          return data;
        }
      });
      setRightSideEmployee(updatedData);
    } else {
      let updatedData = rightSideEmployee.map((data) => {
        if (data.user_id === value.user_id) {
          return {
            ...data,
            checked: true,
          };
        } else {
          return data;
        }
      });
      setRightSideEmployee(updatedData);
    }
  };

  const handleCheckedRight = () => {
    const data = leftSideEmployee.filter((user) => {
      return user.checked === true;
    });
    const remaingData = leftSideEmployee.filter((user) => {
      return user.checked === false;
    });
    let updateAsFalse = data.map((users) => {
      return {
        ...users,
        checked: false,
      };
    });
    let updatedData = [...rightSideEmployee, ...updateAsFalse];
    setRightSideEmployee(updatedData);
    setLeftSideEmployee(remaingData);
    setLeftChecked(false);
    setRightChecked(false);
  };

  const handleCheckedLeft = () => {
    const data = rightSideEmployee.filter((user) => {
      return user.checked === true;
    });
    const remaingData = rightSideEmployee.filter((user) => {
      return user.checked === false;
    });
    let updateAsFalse = data.map((users) => {
      return {
        ...users,
        checked: false,
      };
    });
    let updatedData = [...leftSideEmployee, ...updateAsFalse];
    setLeftSideEmployee(updatedData);
    setRightSideEmployee(remaingData);
    setLeftChecked(false);
    setRightChecked(false);
  };

  const handlAssignedTo = (event, data) => {
    if (data) {
      setValue("id", data?.id);
      setGroupName(data?.label);
      setValue("name", data?.label);
      setGroupId(data?.id);
    } else {
      setValue("name", "");
      setValue("id", null);
      setGroupName("");
    }
  };

  const handleAssignedFrom = (event, data) => {
    if (data) {
      setValue("id", data?.id);
      setRightGroupName(data?.label);
      setValue("workunit_group", data?.label);
      setNewGroupId(data?.id);
    } else {
      setValue("workunit_group", "");
      setValue("id", null);
      setRightGroupName("");
    }
  };

  const filteredWorkUnitGroupLeft = workUnitGroup.filter(
    (obj) => obj.name !== RigthgroupName
  );

  const filteredWorkUnitGroupRight = workUnitGroup.filter(
    (obj) => obj.name !== groupName
  );

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Mui.Grid container sx={{ paddingTop: 2 }}>
          <Mui.Grid item>
            <BackArrow
              actionFunction={() => {
                setMoveEmployee(false);
              }}
            />
          </Mui.Grid>
          <Mui.Grid item>
            <Mui.Typography
              sx={{ fontSize: 24, fontWeight: 700, paddingTop: 1 }}
            >
              {viewAssignDetails?.name}/ Move Employee
            </Mui.Typography>
          </Mui.Grid>
        </Mui.Grid>

        <Mui.Grid container>
          <Mui.Grid xs={5.9}></Mui.Grid>
          <Mui.Grid xs={2.5} sx={{ paddingTop: 1 }}>
            <Mui.Typography
              sx={{
                fontSize: 18,
                color: themes.headLine,
                paddingBottom: 0.5,
                fontWeight: "bold",
              }}
            >
              Department
            </Mui.Typography>

            <CustomAutoComplete
              dataList={department.map((obj) => ({
                ...obj,
                label: obj.department,
              }))}
              selectedValue={departmentName}
              rules={{
                ...register("department_name", {
                  required: "Department name is required",
                }),
              }}
              updateDataFunction={handleDepartment}
              placeHolder="Please select the department name"
              errorMessage={
                errors?.department_name?.message
                  ? errors?.department_name?.message
                  : ""
              }
              textBoxError={errors?.department_name ? true : false}
            />
          </Mui.Grid>
          <Mui.Grid xs={0.2}></Mui.Grid>
          <Mui.Grid xs={2} sx={{ paddingTop: 1 }}>
            {" "}
            <Mui.Typography
              sx={{
                fontSize: 18,
                color: themes.headLine,
                paddingBottom: 0.5,
                fontWeight: "bold",
              }}
            >
              Effective From
            </Mui.Typography>
            <Mui.TextField
              id="from-date"
              type="date"
              size="small"
              {...register("effective_from", {
                required: "Date is required.",
              })}
              error={Boolean(errors.effective_from)}
              helperText={
                errors.effective_from?.message && errors.effective_from.message
              }
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              disableOpenPicker
            />
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid
          container
          sx={{
            mt: 2,
            display: "flex",
            flexDirection: "row",
            justifyContent: "Center",
            alignItems: "Center",
            paddingLeft: 25,
            paddingRight: 25,
          }}
        >
          <Mui.Grid
            container
            component={Mui.Paper}
            sx={{
              mt: 2,
              display: "flex",
              flexDirection: "row",
              justifyContent: "Center",
              alignItems: "Center",
              padding: 2,
              backgroundColor: "#f7f5f6",
            }}
          >
            <Mui.Grid item xs={12} sm={12} md={6} lg={5}>
              <>
                <Mui.Grid
                  container
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "Center",
                    alignItems: "Center",
                  }}
                >
                  <Mui.Grid
                    component={Mui.Paper}
                    sx={{
                      backgroundColor: themes.darkPrimary,
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    <Mui.Typography
                      sx={{
                        padding: 1,
                        fontSize: 20,
                        fontWeight: 700,
                      }}
                    >
                      Assigned From
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>

                <Mui.FormControl fullWidth>
                  <Mui.Typography
                    sx={{
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                  >
                    WorkUnit Group
                  </Mui.Typography>
                  <CustomAutoComplete
                    dataList={filteredWorkUnitGroupLeft.map((obj) => ({
                      ...obj,
                      label: obj.name,
                    }))}
                    selectedValue={groupName}
                    rules={{
                      ...register("name", {
                        required: "Work unit group is required",
                      }),
                    }}
                    updateDataFunction={handlAssignedTo}
                    placeHolder="Please select workunit group"
                    errorMessage={
                      errors?.name?.message ? errors?.name?.message : ""
                    }
                    textBoxError={errors?.name ? true : false}
                  />
                  <Mui.Grid
                    sx={{
                      paddingTop: 2,
                      width: "100%",
                      bgcolor: "background.paper",
                    }}
                    component={Mui.Paper}
                  >
                    <Mui.Card>
                      {/* <Mui.CardHeader
                      sx={{ px: 2, py: 1 }}
                      avatar={
                        <Mui.Checkbox
                          onClick={(event) =>
                            handleToggleAllLeft(event.target.checked)
                          }
                          inputProps={{
                            "aria-label": "all items selected",
                          }}
                        />
                      }
                      title={"Selected Employees"}
                      subheader={`${numberOfChecked()}/${
                        leftSideEmployee.length
                      }`}
                    /> */}
                      {/* <Mui.Divider /> */}
                      <Mui.List
                        sx={{
                          width: "100%",
                          height: {
                            xs: 200,
                            sm: 300,
                            md: 300,
                            lg: 430,
                          },
                          bgcolor: "background.paper",
                          overflow: "auto",
                        }}
                        dense
                        component="div"
                        role="list"
                      >
                        {leftSideEmployee.map((value) => {
                          const labelId = `transfer-list-all-item-${value.user_id}-label`;

                          return (
                            <Mui.ListItemButton
                              key={value.user_id}
                              role="listitem"
                              onClick={handleToggleLeft(value)}
                            >
                              <Mui.ListItemIcon>
                                <Mui.Checkbox
                                  checked={value.checked}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                />
                              </Mui.ListItemIcon>
                              <Mui.ListItemAvatar>
                                <Mui.Avatar
                                  alt={value?.user_name?.charAt(0)}
                                  src={value?.image_url}
                                />
                              </Mui.ListItemAvatar>
                              <Mui.ListItemText
                                id={labelId}
                                primary={`${value.user_name}`}
                              />
                            </Mui.ListItemButton>
                          );
                        })}
                      </Mui.List>
                    </Mui.Card>
                  </Mui.Grid>
                </Mui.FormControl>
              </>
            </Mui.Grid>
            <Mui.Grid item xs={12} sm={12} md={1.5} lg={1}>
              <Mui.Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                sx={{ height: "100%" }}
              >
                <Mui.IconButton
                  onClick={handleCheckedRight}
                  disabled={leftChecked.length === 0}
                  sx={{
                    textTransform: "capitalize",
                    color: themes.headLine,
                  }}
                  variant="contained"
                  size="medium"
                >
                  <ArrowCircleRight color={themes.headLine} fontSize="large" />
                </Mui.IconButton>
                <Mui.IconButton
                  onClick={handleCheckedLeft}
                  disabled={rightChecked.length === 0}
                  sx={{
                    textTransform: "capitalize",
                    color: themes.headLine,
                  }}
                  variant="contained"
                  size="medium"
                >
                  <ArrowCircleLeft color={themes.headLine} fontSize="large" />
                </Mui.IconButton>
              </Mui.Grid>
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={5}>
              <>
                <Mui.Grid
                  container
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "Center",
                    alignItems: "Center",
                  }}
                >
                  <Mui.Grid
                    component={Mui.Paper}
                    sx={{
                      backgroundColor: themes.darkPrimary,
                      paddingLeft: 5.5,
                      paddingRight: 5.5,
                    }}
                  >
                    <Mui.Typography
                      sx={{
                        padding: 1,
                        fontSize: 20,
                        fontWeight: 700,
                      }}
                    >
                      Assigned To
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.FormControl fullWidth>
                  <Mui.Typography
                    sx={{
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                  >
                    WorkUnit Group
                  </Mui.Typography>
                  <CustomAutoComplete
                    dataList={filteredWorkUnitGroupRight.map((obj) => ({
                      ...obj,
                      label: obj.name,
                    }))}
                    selectedValue={RigthgroupName}
                    rules={{
                      ...register("workunit_group", {
                        required: "Work unit group is required",
                      }),
                    }}
                    updateDataFunction={handleAssignedFrom}
                    placeHolder="Please select workunit group"
                    errorMessage={
                      errors?.workunit_group?.message
                        ? errors?.workunit_group?.message
                        : ""
                    }
                    textBoxError={errors?.workunit_group ? true : false}
                  />
                  <Mui.Grid
                    sx={{
                      //   paddingTop: 2,
                      width: "100%",
                      bgcolor: "background.paper",
                    }}
                    component={Mui.Paper}
                  >
                    <Mui.Card>
                      <Mui.List
                        sx={{
                          width: "100%",
                          height: {
                            xs: 200,
                            sm: 300,
                            md: 300,
                            lg: 430,
                          },
                          bgcolor: "background.paper",
                          overflow: "auto",
                        }}
                        dense
                        component="div"
                        role="list"
                      >
                        {rightSideEmployee.map((value) => {
                          const labelId = `transfer-list-all-item-${value.user_id}-label`;

                          return (
                            <Mui.ListItemButton
                              key={value.user_id}
                              role="listitem"
                              onClick={handleToggleRigh(value)}
                            >
                              <Mui.ListItemIcon>
                                <Mui.Checkbox
                                  checked={value.checked}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                />
                              </Mui.ListItemIcon>
                              <Mui.ListItemAvatar>
                                <Mui.Avatar
                                  alt={value?.user_name?.charAt(0)}
                                  src={value?.image_url}
                                />
                              </Mui.ListItemAvatar>
                              <Mui.ListItemText
                                id={labelId}
                                primary={`${value.user_name}`}
                              />
                            </Mui.ListItemButton>
                          );
                        })}
                      </Mui.List>
                    </Mui.Card>
                  </Mui.Grid>
                </Mui.FormControl>
              </>
            </Mui.Grid>
            <Mui.Grid container sx={{ mt: 2 }}>
              <Mui.Grid xs={10.7}></Mui.Grid>
              <CustomButton actionName="Update" typeName="submit" />
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
      </form>
    </React.Fragment>
  );
};
